import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/web/link";
// 友情链接(合作机构)
const linkApi = {
  list(params) {
    return request({
      url: `${baseUrl}/listLink`,
      method: "GET",
      params
    });
  }
};
export default linkApi;
